var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_732",
    "data-name": "Group 732",
    transform: "translate(-40 -169)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1556",
    "data-name": "Rectangle 1556",
    width: 10,
    height: 10,
    rx: 3,
    transform: "translate(40 181)",
    fill: "#ff9e1a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1557",
    "data-name": "Rectangle 1557",
    width: 10,
    height: 10,
    rx: 3,
    transform: "translate(40 169)",
    fill: "#4e4e4e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1558",
    "data-name": "Rectangle 1558",
    width: 10,
    height: 10,
    rx: 3,
    transform: "translate(52 169)",
    fill: "#ff9e1a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1559",
    "data-name": "Rectangle 1559",
    width: 10,
    height: 10,
    rx: 3,
    transform: "translate(52 181)",
    fill: "#ff9e1a"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboard-icon.25d229df9e02bf311347e725741abfd5.svg";
export { ForwardRef as ReactComponent };